<template>
  <div class="app-wrapper top_content" :class="{ bgw: !theme }">
    <!-- <a-button
      @click="toggleCollapsed"
      class="top_left"
      ghost
      :type="theme ? '' : 'primary'"
    >
      <MenuUnfoldOutlined v-if="collapsed" />
      <MenuFoldOutlined v-else />
    </a-button> -->
    <div class="top_menu_list" v-for="menu in topLevelMenuList" :key="menu">
      <div
        @click="toMenu(menu.menuId, menu.isFrame)"
        :class="menu.menuId == selectMenuId ? 'active_menu' : ''"
      >
        {{ menu.menuName }}
      </div>
    </div>
    <div class="avatar-container top_right">
      <div class="avatar-wrapper" style="margin-right: 20px">
        <div class="name">{{ userName }}</div>
      </div>

      <a-dropdown>
        <a-avatar
          src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
        />
        <template v-slot:overlay>
          <a-menu>
            <!-- <a-menu-item>
              <div class="item_content" @click="changeTheme">换个主题</div>
            </a-menu-item> -->
            <a-menu-item>
              <div class="item_content" @click="loginOut">退出登录</div>
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
    </div>
  </div>

  <a-breadcrumb>
    <a-breadcrumb-item v-for="(item, index) in levelList" :key="index">{{
      item.meta.title
    }}</a-breadcrumb-item>
  </a-breadcrumb>
</template>

<script>
import menuApi from "@axios/sys/menu";
import { useStore } from "vuex";
import { inject, ref } from "vue";
import { MenuUnfoldOutlined, MenuFoldOutlined } from "@ant-design/icons-vue";
import { Modal, destroyAll } from "ant-design-vue";
import { useRouter } from "vue-router";

export default {
  name: "top",
  components: {
    MenuUnfoldOutlined,
    MenuFoldOutlined,
  },
  props: {
    theme: {
      type: Boolean,
      default: true,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["setValue", "setValue"],
  setup(props, context) {
    const changeTheme = inject("changeTheme");
    const toggleCollapsed = inject("toggleCollapsed");
    const store = useStore();
    const router = useRouter();
    let topLevelMenuList = ref([]);
    const userName = store.state.userName;
    let selectMenuId = ref(1);
    const loginOut = () => {
      Modal.confirm({
        content: "是否确定退出？",
        onOk() {
          localStorage.clear();
          sessionStorage.clear();
          router.push({
            name: "login",
          });
        },
        cancelText: "取消",
        okText: "确定",
        onCancel() {
          Modal.destroyAll();
        },
      });
    };

    /**
     * 选择菜单
     * @param menuId
     * @param isFrame
     */
    const toMenu = (menuId, isFrame) => {
      selectMenuId.value = menuId;
      //数据平台 并且是外部连接
      if (menuId == 2 && isFrame == 0) {
        window.location.href = window.location.origin + "/data-report/";
      }
      context.emit("setValue", { val: menuId });
      //findTopLevelMenuList();
      // window.location.href = window.location.origin + '/train-admin/'
      // if(type == 1){
      //   window.location.href = window.location.origin + '/train-admin/'
      // }else if(type == 2){
      //
      //   window.location.href = window.location.origin + '/data-report/'
      // }
    };
    const findTopLevelMenuList = () => {
      let params = {};
      menuApi.findTopLevelMenuList(params).then((res) => {
        res.splice(1, 1);
        if (!res) return;
        //console.log(JSON.stringify(res))
        topLevelMenuList.value = res;
        //console.log(selectMenuId);
      });
    };
    findTopLevelMenuList();
    return {
      toMenu,
      changeTheme,
      toggleCollapsed,
      loginOut,
      userName,
      topLevelMenuList,
      selectMenuId,
    };
  },
  computed: {
    levelList() {
      let levelList = null;
      let matched = this.$route.matched.filter((item) => item.name);
      const first = matched[0];
      levelList = matched;
      return levelList;
    },
  },

  methods: {},
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.avatar-wrapper {
  color: #666;
}
.top_menu_list {
  height: 50;
  display: flex;
  justify-content: flex-start;
  div {
    height: 50px;
    line-height: 50px;
    color: #666666;
    padding: 0 20px;
    box-sizing: border-box;
    cursor: pointer;
  }

  .active_menu {
    background: #ccc !important;
  }
}

.item_content {
  padding: 10px 20px;
}

.top_left {
  margin-left: 20px;
  margin-right: 20px;
  color: #666;
}
.top_left:hover {
  background-color: #cccccc !important;
}
.top_left:focus {
  background-color: #cccccc !important;
}
.top_content {
  height: 50px;
  line-height: 50px;
  background: #f2f2f2;
  color: #fff;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  display: relative;
}

.bgw {
  background: #fff;
  color: #304156;
  border-bottom: 2px solid #eee;
}

.top_right {
  display: flex;
  margin-right: 20px;
  position: absolute;
  right: 20px;
  align-items: center;
}

.user {
  cursor: pointer;
}

.bgw /deep/ .ant-breadcrumb {
  color: #000;
}

.bgw /deep/ .ant-breadcrumb > span:last-child {
  color: #000;
}

.bgw /deep/ .ant-breadcrumb-separator {
  color: #000;
}

.click_nav {
  height: 50px;
  padding: 0px 20px;
}
</style>
